export const LOGIN = 'AUTH/LOGIN';
export const LOGIN_PENDING = `${LOGIN}_PENDING`;
export const LOGIN_FULFILLED = `${LOGIN}_FULFILLED`;
export const LOGIN_REJECTED = `${LOGIN}_REJECTED`;

export const login = (payload) => ({
  type: LOGIN,
  payload,
});

export const RESET = `${LOGIN}_RESET`;

export const reset = () => ({
  type: RESET,
});

export const LOGOUT = 'AUTH/LOGOUT';
export const LOGOUT_PENDING = `${LOGOUT}_PENDING`;
export const LOGOUT_FULFILLED = `${LOGOUT}_FULFILLED`;
export const LOGOUT_REJECTED = `${LOGOUT}_REJECTED`;

export const logout = () => ({
  type: LOGOUT,
});

export const UPDATE_SUCCESS_REDIRECT = 'AUTH/LOGIN/UPDATE_SUCCESS_REDIRECT';
export const RESET_SUCCESS_REDIRECT = 'AUTH/LOGIN/RESET_SUCCESS_REDIRECT';

export const updateSuccessRedirect = (url = '', validPlans = []) => ({
  type: UPDATE_SUCCESS_REDIRECT,
  payload: {
    url,
    validPlans,
  },
});

export const resetSuccessRedirect = () => ({
  type: RESET_SUCCESS_REDIRECT,
});
